/**
 * Check if the chatbot feature is allowed on the current frontend domain/origin.
 *
 * Allowed domains specified via VUE_APP_CHATBOT_ALLOWED_DOMAINS environment variable.
 * Defaults to: https://devtesting.zircly.com, https://gunatesting.zircly.com, http://localhost:8080
 */
export function isChatbotDomainAllowed() {
  if (process.env.VUE_APP_SHOW_ZIRCLY_AI === 'false') {
    return false;
  }

  const rawAllowed = process.env.VUE_APP_CHATBOT_ALLOWED_DOMAINS !== undefined
    ? process.env.VUE_APP_CHATBOT_ALLOWED_DOMAINS
    : 'https://devtesting.zircly.com,https://gunatesting.zircly.com';

  const allowedList = rawAllowed
    .split(',')
    .map(d => d.trim().toLowerCase().replace(/\/+$/, ''))
    .filter(Boolean);

  if (!allowedList.length) {
    return false;
  }

  const currentOrigin = window.location.origin ? window.location.origin.toLowerCase().replace(/\/+$/, '') : '';
  const currentHost = window.location.host ? window.location.host.toLowerCase() : '';
  const currentHostname = window.location.hostname ? window.location.hostname.toLowerCase() : '';

  return allowedList.some(allowed => {
    // Exact origin match (e.g. http://localhost:8080 or https://devtesting.zircly.com)
    if (currentOrigin && currentOrigin === allowed) {
      return true;
    }

    // Match hostname / domain without scheme (e.g. devtesting.zircly.com or gunatesting.zircly.com)
    const allowedHost = allowed.replace(/^https?:\/\//, '');
    if (currentHost === allowedHost || currentHostname === allowedHost) {
      return true;
    }

    return false;
  });
}
